var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 716.5,
    cy: 223.5,
    r: 62.5,
    fill: "#17C7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.998 473.55C263.784 432.967 274.082 355.929 233.001 301.482C191.92 247.036 115.014 235.796 61.228 276.379C7.4423 316.961 -2.85623 393.999 38.2249 448.446C79.306 502.892 156.212 514.132 209.998 473.55Z",
    fill: "url(#loaderGradient37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 608.743,
    cy: 525.658,
    rx: 163,
    ry: 166,
    transform: "rotate(-2.37658 608.743 525.658)",
    fill: "#ED801B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient37",
    x1: 123.536,
    y1: 414.29,
    x2: 174.014,
    y2: 257.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg37);
export default __webpack_public_path__ + "static/media/37.3d57c099.svg";
export { ForwardRef as ReactComponent };